import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ConfigService,
  ApplicationBaseService,
  ApplicationQueryResult,
  ApplicationOfferBundleData,
} from "common";
import { ApplicationData } from "../application.model";
import { switchMap } from "rxjs/operators";
import { SsoAccountFacade, SsoAccountData } from "common";
import { AppSettings } from "projects/portal/src/app.settings";

@Injectable({
  providedIn: "root",
})
export class ApplicationRemote extends ApplicationBaseService<ApplicationData> {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    private appSettings: AppSettings,
    private ssoAccountFacade: SsoAccountFacade
  ) {
    super(http, configService);
  }

  queryByEntity(entityId: number): Observable<ApplicationQueryResult> {
    return this.ssoAccountFacade
      .getCurrentSsoAccount$()
      .pipe(
        switchMap((currentSsoAccount: SsoAccountData) =>
          this.queryBase(currentSsoAccount.id, entityId)
        )
      );
  }

  private queryBase(customerId: number, entityId: number): Observable<ApplicationQueryResult> {
    const params = {
      customerId,
      entityId,
    };
    return super.query(params);
  }

  getAgreementReadyOfferBundle(applicationId: number
    ): Observable<ApplicationOfferBundleData> {
      const url = `${this.appSettings.applications.url}/api/offer-bundle/application/${applicationId}/agreement-ready`;
      return this.http.get<ApplicationOfferBundleData>(url);
    }
}
